import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { ProgramsListFilter, ProgramsUsersListFilter } from '../types';

type ProgramsParams = {
  filter?: ProgramsListFilter;
  pagination?: Partial<Pagination>;
};

type ProgramsUsersParams = {
  filter?: Partial<ProgramsUsersListFilter>;
  pagination?: Partial<Pagination>;
};

// TODO: split programs
export const getProgramsInfiniteQueryKey = ({ filter = {}, pagination = {} }: ProgramsParams) =>
  generateQueryKey(['programs', 'list', 'infinite', { filter, pagination }]);

export const getProgramUsersKey = ({ filter = {}, pagination = {} }: ProgramsUsersParams) =>
  generateQueryKey(['programs', 'users', { filter, pagination }]);

export const getProgramUsersInfiniteQueryKey = ({ filter = {}, pagination = {} }: ProgramsUsersParams) =>
  generateQueryKey([...getProgramUsersKey({ filter, pagination }), 'infinite']);

export const getProgramQueryKey = ({ programId }: { programId?: string }) =>
  generateQueryKey(['programs', 'detail', programId]);
